// Item in Statement Info when generating Royalty Statement
import React from "react";
import { commaSepThou, makeAdjustedString } from '../../../util.js';
import JSON5 from 'json5';


import {
  Pane,
  Paragraph,
} from 'evergreen-ui';



const RoyaltyStatementSummary = props => {

  const startDate = props.startDate
  const endDate = props.endDate
  const selected = props.items || []
  const currency = props.currency
  const salesByRegion = props.salesByRegion || false; // Assume salesByRegion prop, default to false


  return (
    <Pane>
      <Paragraph size={400} marginTop={8} marginBottom={8} ><b>Statement Period:</b> {startDate} through {endDate}</Paragraph>

      {selected.length > 0 &&
        <table width="80%" padding="4px" style={{
          color: "#474d66",
          fontSize: "12px",
          textAlign: "left",
          borderCollapse: "collapse"
        }}>
          <thead>
            <tr height={32} style={{ backgroundColor: "#F9FAFC", borderTop: "1px solid #E6E8F0", borderBottom: "1px solid #E6E8F0", borderLeft: "1px solid #E6E8F0", borderRight: "1px solid #E6E8F0" }}>
              <th style={{ paddingLeft: "8px" }}>PRODUCTS ({selected.length})</th>
              {salesByRegion && <th style={{ textAlign: "left" }}>REGION</th>}
              <th >CURRENT BALANCE</th>
            </tr>
          </thead>
          <tbody>
            {selected.map((item, index) => {
              if (!item?.product || !item?.statementInfo) {
                return null;
              }

              try {
                // Parse product and creator if they are strings
                let productData = item.product;
                if (typeof item.product === 'string') {
                  try {
                    productData = JSON5.parse(makeAdjustedString(item.product));
                  } catch (e) {
                    console.error("Failed to parse item.product string:", item.product, e);
                    productData = {}; // Fallback to empty object on parse error
                  }
                }

                // We don't use creatorData in this component currently, but good practice to parse if needed elsewhere
                // let creatorData = item.creator;
                // if (typeof item.creator === 'string') {
                //   try {
                //     creatorData = JSON5.parse(makeAdjustedString(item.creator));
                //   } catch (e) {
                //     console.error("Failed to parse item.creator string:", item.creator, e);
                //     creatorData = {};
                //   }
                // }

                const adjustedStatementString = makeAdjustedString(item.statementInfo);
                const statementInfo = JSON5.parse(adjustedStatementString);
                const currentBalance = commaSepThou(Math.abs(statementInfo.lifeCredit - statementInfo.lifeDebit - parseFloat(item.paid || 0)).toFixed(2));
                const balNegCur = (statementInfo.lifeDebit + parseFloat(item.paid || 0)) > statementInfo.lifeCredit;

                // --- Debugging Product Title (using parsed productData) ---
                console.log("RoyaltyStatementSummary - Parsed productData:", productData);
                console.log("RoyaltyStatementSummary - productData.productWork:", productData?.productWork);
                console.log("RoyaltyStatementSummary - productData.productWork.title:", productData?.productWork?.title);
                // --- End Debugging ---

                const productTitle = productData?.productWork?.title || 'Untitled Product Title';
                const productFormat = productData?.format?.description || '';
                const productDisplayString = productFormat && productTitle !== 'Untitled Product Title'
                  ? `${productTitle} (${productFormat})`
                  : productTitle;

                // --- Revised Region Logic (item.region is also a string) ---
                let actualRegionName = 'N/A';
                if (salesByRegion && item.region) {
                  if (typeof item.region === 'object' && item.region.name) { // Should not happen if it's a string from log
                    actualRegionName = item.region.name;
                  } else if (typeof item.region === 'string') {
                    try {
                      const regionObj = JSON5.parse(makeAdjustedString(item.region));
                      actualRegionName = regionObj.name || 'N/A (parsed, no name)';
                    } catch (e) {
                      console.error(`Failed to parse region string for item id ${item.id || 'unknown'}:`, item.region, e);
                      actualRegionName = 'N/A (parse error)';
                    }
                  }
                }
                const regionName = salesByRegion ? actualRegionName : null;
                // --- End Region Logic ---

                return (
                  <tr key={item.product?.id || index} height={32} style={{ backgroundColor: "white", borderBottom: "1px solid #E6E8F0", borderLeft: "1px solid #E6E8F0", borderRight: "1px solid #E6E8F0" }}>
                    <td style={{ paddingLeft: "8px" }}>{productDisplayString}</td>
                    {salesByRegion && <td>{regionName}</td>}
                    <td>{balNegCur ? "-" : ""}{currency}{currentBalance}</td>
                  </tr>
                )
              } catch (error) {
                console.error('Error processing royalty statement item:', error);
                return null;
              }
            }).filter(Boolean)}
          </tbody>
        </table>
      }

    </Pane>
  )
}


export default RoyaltyStatementSummary;
